import type { FC } from "react";
import { InnerCRUD } from "@/shared/components";
import {
  ContractPaymentsListQuery,
  type ContractPaymentsListRow,
} from "@/admin/entities/contractPayments";
import {
  getColumnsConfig,
  getTableData,
  getTextsConfig,
  mapColumns,
} from "./config";

interface OrganizationContractPaymentsProps {
  id?: string;
}

/**
 * Вкладка «Платежи» у организации: платежи всех её контрактов. Создания и
 * правки нет, платежи рождает расписание контракта и закрытие месяца,
 * поэтому список только читается, а действия это смена статуса в строке.
 */
export const OrganizationContractPayments: FC<
  OrganizationContractPaymentsProps
> = ({ id }) => {
  return (
    <InnerCRUD<ContractPaymentsListRow>
      listQuery={ContractPaymentsListQuery}
      listQueryVariables={{ filter: { organizationId: id } }}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={getColumnsConfig()}
      texts={getTextsConfig()}
    />
  );
};
